import React, { useEffect, useRef } from 'react';
import styles from './DesignUserCard.module.scss';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCalendar, faDollar, faFlask, faHeart, faMapMarkerAlt, faPencil, faTrophy, faUser } from '@fortawesome/free-solid-svg-icons';
import { ProfilePicDesign } from '../../Profile/ProfilePic/ProfilePic';
import axiosHelper from '../../../helpers/axiosHelper';
import { DesignDetails, User } from '../../../global';
import { useNavigate } from 'react-router-dom';
import { useStoreState } from 'pullstate';
import { getCurrentDesign, getCurrentUser } from '../../../store/Selectors';
import { designUploadDateString, fullPathLogo, fullPathLogoUser } from '../../../helpers/utils';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { awardsUrlForContest, briefUrlForContest, userUrlForUser } from '../../../helpers/navigationUtils';

interface Props {
  design: DesignDetails;
}

export const DesignUserCardWLF: React.FC<Props> = ({ design }) => {
  const redirect = useNavigate();

  return (
    <div className={`col-12 text-center bg-light radius-m p-5   ${styles.designUserCardWrapper}`}>
      <div className="row">
        <div className="col-12 col-md-12  col-lg-12 text-center  text-lg-center">
          <div style={{ height: '60px', overflow: 'hidden' }}>
            <span className="sub-title color-blue mb-2  ">{design.name}</span>
          </div>
          <div className="text mb-7">{design.contest.contestCategory}</div>
        </div>
        <div className="col-12 col-md-12 col-lg-12 ">
          <div className={` ${styles.profilePic} mb-5`}>
            {/* {console.log(userImg.current)} */}
            <ProfilePicDesign image={design.designer.logoAttachment?.s3Path} editable={false}>
              {/* <div className={`${styles.badges} `}>
                <div className={`${styles.badge} bg-red color-light`}>
                  <FontAwesomeIcon icon={faFlask as IconProp} />
                </div>
                <div className={`${styles.badgeOver} bg-green color-light`}>
                  <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} />
                </div>
              </div> */}
            </ProfilePicDesign>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="info mt-7  d-block d-md-flex flex-md-column d-lg-block align-content-center ">
          <div className="d-flex justify-content-start  mb-3 me-0 me-md-3 me-lg-0">
            <div className="d-flex flex-column col-3 justify-content-center">
              <FontAwesomeIcon icon={faUser as IconProp} className=" text color-blue me-4" />
            </div>
            <div className="text text-start align-self-center color-blue cursor-pointer " onClick={() => redirect(userUrlForUser(design.designer.nameForURL))}>
              {design.designer.username}
            </div>
          </div>
          <div className="d-flex justify-content-start mb-3 me-0 me-md-3 me-lg-0">
            <div className="d-flex flex-column col-3  justify-content-center">
              <FontAwesomeIcon icon={faCalendar as IconProp} className=" text color-blue me-4" />
            </div>
            <div className="text text-start align-self-center color-dark">Posted: {designUploadDateString(design.uploadDate)}</div>
          </div>
          <div className="d-flex justify-content-start mb-3 me-0 me-md-3 me-lg-0">
            <div className="d-flex flex-column col-3  justify-content-center">
              <FontAwesomeIcon icon={faTrophy as IconProp} className=" text color-blue me-4" />
            </div>
            <div className="text text-start align-self-center color-blue cursor-pointer" onClick={() => redirect(briefUrlForContest(design.contest.nameForURL))}>
              {design.contest.name}
            </div>
          </div>
          {/* <div className="d-flex justify-content-start mb-3">
            <div className="d-flex flex-column col-3  justify-content-center">
              <FontAwesomeIcon icon={faHeart as IconProp} className=" text color-blue me-4" />
            </div>
            <div className="text text-start align-self-center ">{props.votes} votes</div>
          </div> */}
          {design.contest.contestCategory && (
            <div className="d-flex justify-content-start mb-3">
              <div className="d-flex flex-column col-3  justify-content-center">
                <FontAwesomeIcon icon={faPencil as IconProp} className=" text color-blue me-4" />
              </div>
              <div className="text text-start color-blue cursor-pointer align-self-center " onClick={() => redirect(briefUrlForContest(design.contest.nameForURL))}>
                {design.contest.contestCategory}
              </div>
            </div>
          )}

          <div className="d-flex justify-content-start mb-3">
            <div className="d-flex flex-column col-3  justify-content-center">
              <FontAwesomeIcon icon={faDollar as IconProp} className=" text color-blue me-4" />
            </div>
            <div className="text text-start align-self-center d-flex flex-row align-items-center justify-content-center">
              Award won:
              <span className={` ms-1 text color-blue cursor-pointer`} onClick={() => redirect(awardsUrlForContest(design.contest.nameForURL))}>
                {`${design.awards.length > 0 ? `${design.awards[0].title}` : 'None'}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
